import React from 'react';
import { FiSearch, FiRotateCcw } from 'react-icons/fi';

const FilterBar = ({ filters, onFilterChange, departments, semesters, examTypes }) => {
  const hasActiveFilters = Object.values(filters).some(val => Boolean(val));

  return (
    <div className="card" style={{ padding: '16px', marginBottom: '24px' }}>
      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
        
        {/* Search Input */}
        <div style={{ flex: '1 1 240px', position: 'relative' }}>
          <FiSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
          <input
            type="text"
            className="form-input"
            style={{ paddingLeft: '36px', width: '100%', height: '40px' }}
            placeholder="Search notes by title or subject..."
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
          />
        </div>

        {/* Department Filter */}
        <div style={{ minWidth: '160px', flex: '1 1 150px' }}>
          <select
            className="form-input"
            style={{ height: '40px' }}
            value={filters.department}
            onChange={(e) => onFilterChange('department', e.target.value)}
          >
            <option value="">All Departments</option>
            {departments?.map(dept => (
              <option key={dept} value={dept}>{dept}</option>
            ))}
          </select>
        </div>

        {/* Semester Filter */}
        <div style={{ minWidth: '130px', flex: '1 1 120px' }}>
          <select
            className="form-input"
            style={{ height: '40px' }}
            value={filters.semester}
            onChange={(e) => onFilterChange('semester', e.target.value)}
          >
            <option value="">All Semesters</option>
            {semesters?.map(sem => (
              <option key={sem} value={sem}>Sem {sem}</option>
            ))}
          </select>
        </div>

        {/* Material Type Filter */}
        <div style={{ minWidth: '130px', flex: '1 1 120px' }}>
          <select
            className="form-input"
            style={{ height: '40px' }}
            value={filters.type}
            onChange={(e) => onFilterChange('type', e.target.value)}
          >
            <option value="">All Types</option>
            <option value="note">Notes</option>
            <option value="pastpaper">Past Papers</option>
          </select>
        </div>

        {/* Exam Type Filter (If Past Paper selected) */}
        {filters.type === 'pastpaper' && (
          <div style={{ minWidth: '140px', flex: '1 1 130px' }}>
            <select
              className="form-input"
              style={{ height: '40px' }}
              value={filters.examType}
              onChange={(e) => onFilterChange('examType', e.target.value)}
            >
              <option value="">All Exams</option>
              {examTypes?.map(type => (
                <option key={type} value={type}>
                  {type.toUpperCase()}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Clear Filters Button */}
        {hasActiveFilters && (
          <button
            type="button"
            className="btn btn-ghost btn-sm"
            onClick={() => {
              ['search', 'department', 'semester', 'subject', 'type', 'year', 'examType'].forEach(
                key => onFilterChange(key, '')
              );
            }}
          >
            <FiRotateCcw /> Reset
          </button>
        )}

      </div>
    </div>
  );
};

export default FilterBar;